module.exports = __webpack_public_path__ + "static/media/temperature-low.2516b7fb.svg";